import React from "react";
import axios from "axios";
// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

// core components
import Button from "components/CustomButtons/Button.js";

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import SimpleForm from "views/component/SimpleForm";

const useStyles = makeStyles(modalStyle);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function WorkingHourPop(props) {
    const { factory, modal, onClose, onSave } = props;

    const classes = useStyles();
    const setModal = function (modal) {
        onClose(modal);
    }
    const handleSave = function (editData) {
        if (onSave) onSave();
        setModal(false);
    }
    return (
        <Dialog classes={{ root: classes.center, paper: classes.modal }}
            open={modal} transition={Transition} keepMounted fullWidth
            onClose={() => setModal(false)}
            aria-labelledby="modal-slide-title" aria-describedby="modal-slide-description" >
            <DialogTitle id="classic-modal-slide-title" disableTypography className={classes.modalHeader}>
                <Button justIcon className={classes.modalCloseButton} key="close"
                    aria-label="Close" color="transparent" onClick={() => setModal(false)}>
                    <Close className={classes.modalClose} />
                </Button>
                <h4 className={classes.modalTitle}>일과시간 등록</h4>
            </DialogTitle>
            <DialogContent id="modal-slide-description" className={classes.modalBody}>
                <SimpleForm domain="aps" tableName="workingHour" insertAttr={factory} params={factory} writeOnly
                    onSave={handleSave} onCancel={() => setModal(false)}/>
            </DialogContent>
        </Dialog>
    );
}